// extracted by mini-css-extract-plugin
export default {"msgContainer":"NotificationBar_msgContainer__zkNgE","successMsg":"NotificationBar_successMsg__r5ZJE","text":"NotificationBar_text__ni5i0","close":"NotificationBar_close__2XCAC"};